export function startLoading(dispatch: any) {
  dispatch({ type: "START_LOADING" });
}

export function stopLoading(dispatch: any) {
  dispatch({ type: "STOP_LOADING" });
}
